// extracted by mini-css-extract-plugin
export default {"base":"LineChartDisplay_base__GnUUG","select":"LineChartDisplay_select__wxEHQ"};